import React, { useState } from "react";
import { ImCross } from "react-icons/im";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import { MyContextSupply } from "../../Context";
import { toast } from "react-toastify";

const UpdateProfile = ({
  updateAccountInfo,
  setUpdateAccountInfo,
  setIsClickedForUpdate,
}) => {
  const { token, toggleUpdatedAccountInfo } = MyContextSupply();
  const [isCurrentPasswordShow, setIsCurrentPasswordShow] = useState(false);
  const [newPasShow, setNewPassShow] = useState(false);
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const { fname, lname, email, mobile, password, newpassword } =
    updateAccountInfo;

  const OnChangeFormInfo = (e) => {
    const { name, value } = e.target;
    setUpdateAccountInfo((previous) => {
      return { ...previous, [name]: value };
    });
  };

  const OnSubmitUpdateAccountInfo = (e) => {
    e.preventDefault();
    if (
      password !== "" &&
      fname !== "" &&
      lname !== "" &&
      email !== "" &&
      mobile !== ""
    ) {
      axios
        .put(
          "https://stechbackend-9r4c.onrender.com/update/user/account",
          { fname, lname, email, mobile, password, newpassword },
          { headers: { Authorization: token }, withCredentials: true }
        )
        .then((res) => {
          if (res.status === 201) {
            toast.success(res.data.message);
            toggleUpdatedAccountInfo();
            setIsClickedForUpdate(false);
          }
        })
        .catch((error) => {
          const message = error.response.data.message;
          if (error) {
            toast.warn(message, { position: "top-center", autoClose: 2000 });
          }
        });
    } else {
      toast.warn("Please fill required fields, inputs can't be empty.");
    }
  };

  return (
    <section className="user-update-profile">
      <div className="shipping_form_container">
        <div className="form_titles_close_btn_flex">
          <h3>Update Your account information</h3>
          <ImCross
            onClick={() => setIsClickedForUpdate(false)}
            className="cross_shipping_Form"
          />
        </div>
        <form onSubmit={OnSubmitUpdateAccountInfo}>
          <label htmlFor="fname">First Name:</label>
          <input
            type="text"
            name="fname"
            value={fname}
            onChange={OnChangeFormInfo}
            placeholder="enter first name*"
            className="shipping_input"
          />
          <label htmlFor="lname">Last Name:</label>
          <input
            type="text"
            name="lname"
            value={lname}
            onChange={OnChangeFormInfo}
            placeholder="enter last name"
            className="shipping_input"
          />
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            name="email"
            value={email}
            onChange={OnChangeFormInfo}
            placeholder="enter email"
            className="shipping_input"
          />

          <label htmlFor="email">Mobile:</label>
          <input
            type="tel"
            name="mobile"
            value={mobile}
            onChange={OnChangeFormInfo}
            placeholder="enter mobile number"
            className="shipping_input"
          />
          <label htmlFor="password">Current Password:</label>
          <div style={{ position: "relative" }}>
            <input
              type={`${isCurrentPasswordShow ? "text" : "password"}`}
              name="password"
              value={password}
              onChange={OnChangeFormInfo}
              autoComplete="off"
              placeholder="enter your current password"
              className="shipping_input"
            />
            <p
              onClick={() => setIsCurrentPasswordShow(!isCurrentPasswordShow)}
              className="showCurrentPassword"
            >
              {isCurrentPasswordShow ? <AiFillEye /> : <AiFillEyeInvisible />}
            </p>
          </div>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Want to Change Password!"
            />
          </FormGroup>
          {checked && (
            <>
              <label htmlFor="password">New Password:</label>
              <div style={{ position: "relative" }}>
                <input
                  type={`${newPasShow ? "text" : "password"}`}
                  name="newpassword"
                  value={newpassword}
                  onChange={OnChangeFormInfo}
                  autoComplete="off"
                  placeholder="enter new password"
                  className="shipping_input"
                />
                <p
                  onClick={() => setNewPassShow(!newPasShow)}
                  className="showCurrentPassword"
                >
                  {newPasShow ? <AiFillEye /> : <AiFillEyeInvisible />}
                </p>
              </div>
            </>
          )}
          <button type="submit" className="ProccedToPay_btn">
            Update Account
          </button>
        </form>
      </div>
    </section>
  );
};

export default UpdateProfile;
